import { Injectable } from '@angular/core';
import { LoggerProvider, LogLevel } from "../logger/logger";
import { Events, Platform } from "ionic-angular";
import { BackgroundFetch, BackgroundFetchConfig } from "@ionic-native/background-fetch";
import moment from 'moment';


@Injectable()
export class CronProvider {
  private log_level: LogLevel = LogLevel.Error;
  private log_label_main: string = "CronProvider";

  private interval: any;
  private intervalTimeout: number = 30 * 1000; // in s

  public lastRun: moment.Moment = null;
  public nextRun: moment.Moment = null;

  constructor(
    private logger: LoggerProvider,
    public events: Events,
    public platform: Platform,
    private backgroundFetch: BackgroundFetch,
  ) {
    const me = this;
    let log_label: string = me.log_label_main + '::constructor';
    me.logger.setLogLevel(me, LogLevel.Warning);

    me.logger.warn(me, log_label);
  }

  appReady(): Promise<any> {
    const me = this;
    let log_label = me.log_label_main + '::appReady';

    me.logger.warn(me, log_label);

    return new Promise((resolve, reject) => {

      // set log level
      me.logger.setLogLevel(me, me.log_level);

      // start interval
      if (me.interval) {
        reject(new Error("interval already set"));

      } else {

        me.interval = setInterval(() => {
          me.runInterval();

        }, me.intervalTimeout);

        resolve();
      }

      // start background fetch
      if (
        me.platform.is('ios')
        ||
        me.platform.is('android')
      ) {
        // ios or android
        const config: BackgroundFetchConfig = {
          stopOnTerminate: true, // Set true to cease background-fetch from operating after user "closes" the app. Defaults to true.
        };

        me.backgroundFetch.configure(config)
          .then(() => {
            me.logger.warn(me, log_label + ":backgroundFetch:initialized");

            me.runInterval(true);

            /*
                        // SIA-26, 2019-02-11
                        me.clearLog();

                        // 2019-02-25
                        me.checkPlayerStatus();

                        me.callKeepAlive().then(() => {
                          me.logger.warn(me, log_label + ":backgroundFetch:callKeepAlive:done");

                          me.backgroundFetch.finish();

                        }, error => {
                          me.logger.error(me, log_label + ":backgroundFetch:callKeepAlive:error", {error: error});

                          me.backgroundFetch.finish();
                        });
            */

          })
          .catch(error => {
            me.logger.error(me, log_label + ":backgroundFetch:error", {error: error});
          });

        // Start the background-fetch API. Your callbackFn provided to #configure will be executed each time a background-fetch event occurs. NOTE the #configure method automatically calls #start. You do not have to call this method after you #configure the plugin
        me.backgroundFetch.start().then(data => {
          me.logger.warn(me, log_label + ":backgroundFetch:started", {data: data});

        }, error => {
          me.logger.error(me, log_label + ":backgroundFetch:started:error", {error: error});

        });
      }

    });
  }

  runInterval(background: boolean = false): void {
    const me = this;
    let log_label = me.log_label_main + '::runInterval';

    me.lastRun = moment();
    me.nextRun = moment().add(me.intervalTimeout, "milliseconds");

    me.logger.warn(me, log_label, {
      lastRun: me.logger.formatMoment(me.lastRun),
      nextRun: me.logger.formatMoment(me.nextRun)
    });

    me.events.publish('cron:run', background);
  }
}



// WEBPACK FOOTER //
// ./src/providers/cron/cron.ts